import { DynamicConfig } from './types';

export const defaultConfig: DynamicConfig = {
  ApplicationUrl: process.env.REACT_APP_APPLICATION_URL || 'https://localhost:44309',
  Clients: '',
  Map: {
    mapBoxApiToken: process.env.REACT_APP_MAPBOX_API_KEY || '',
    zoom: 18,
    minZoom: 10,
    maxZoom: 18,
    type: 'mapbox/outdoors-v12',
  },
  DefaultLanguage: 'en', // default language en, sl, de
};

class GlobalConfig {
  config: DynamicConfig = defaultConfig;

  public get(): DynamicConfig {
    return this.config;
  }

  public set(value: DynamicConfig): void {
    this.config = value;
  }
}

export const globalConfig = new GlobalConfig();

export const globalConfigUrl = '/config/config.json';
